
export const DOWNLOAD_PDF_HTML_STYLES = `
        
    body {
        top: 0 !important;
    }
    .goog-te-banner-frame, .goog-te-banner-frame * {
        display: none !important;
        visibility: hidden !important;
    }

    .article-body {        
        border-bottom: 1px solid #bcbec0;   
        padding-bottom: 10px;
        margin-bottom: 40px;
    }
    
    .article-body__source {
        color: #000;        
        font-size: 14px;
        line-height: 25px;
    }
    
    .article-body__headline {
        color: #000;        
        font-size: 24px;
        line-height: 32px;
        padding: 30px 0;
    }
    
    .preview-article-page .article-body__content {
        color: #000;        
        font-size: 14px;
        line-height: 25px;
        padding-bottom: 50px;
        padding-top: 30px;
        word-wrap: break-word;
    }
    
    .section-title {
        border-bottom: 1px solid #bcbec0;
        color: #373739;
        font-size: 18px;
        margin: 15px 0;
        padding: 5px 0;
    }
    
        
    .article-details__section-third-parties {        
        font-size: 14px;
        margin-bottom: 35px;
    }
    
    .article-details__section-third-parties .entity-profile {
        display: none;        
    }










    .article-details__section-risk-angle-matches .subtitles {
        color: #373739;        
        display: flex;
        font-weight: bold;
        margin: 5px 0;    
    }
    
    .article-details__section-risk-angle-matches .sectionRiskAngles__rows {
        margin-bottom: 5px;
        clear: both;
    }   
        
    .article-details__section-risk-angle-matches .subtitles__risk-and-level {        
        float: left;
    }
    
    .article-details__section-risk-angle-matches .subtitles__index-term {
        padding-left: 15px;
        float: right;
    }
    
    .article-details__section-risk-angle-matches .risk-angle-level {
        float: left;           
    }
        
    .article-details__section-risk-angle-matches .index-term-matched {
        float: right;    
    }
    
    .risk-angle-name {
        font-weight: normal;
    }
    
    .index-term-matched {
        font-weight: normal;
    }
        
    .risk-bullet {
        border-radius: 50%;
        display: inline-block;        
        font-weight: bold;
        height: 25px;
        line-height: 25px;
        text-align: center;
        width: 25px;
        margin-left: 20px;
    }
    .risk-bullet.low {        
        background-color: #ffeda0;
        color: #000;
        font-weight: bold;
    }
    .risk-bullet.medium {
        background-color: #feb24c;
        color: #000;
        font-weight: bold;
    }
    .risk-bullet.high {       
        background-color: #f03b20;
        color: #000;
        font-weight: bold;        
    }
    
    
    
    
    
    
    
    
    
    .article-details__section-about {
        clear: both;
        padding-top: 10px;
    }
    
    .article-details__section-about .section-about__rows {        
        color: #373739;        
        font-size: 14px;
        line-height: 25px;
    }
    
    .article-details__section-about .section-about__rows span:first-child {
        font-weight: bold;
    }
    .article-details__section-about .section-about__rows .date-label span:first-child {
        font-weight: normal;
    }
    
    
    .header {
        background-color: #373737;
        color: #fff;
        font-size: 10px;
        min-height: 43px;
        min-width: 1024px;
        position: relative;
        z-index: 90;
        margin-bottom: 30px;
    }
    
    .header__menu-wrapper{
        margin-left: 10px;
    }
    
    .header__logo {
        color: white !important;
        height: 43px;        
        padding: 0 15px;
        position: absolute;
        text-decoration: none;
        z-index: 1;
    }
    
    .header__logo span, sup {
            font-family: Lato-Light, sans-serif;
    }
    
    .header__logo--company {
        font-size: 14px;
        font-weight: 400;
        position: relative;
        top: 2px;
    }
        
    .header__logo--product {
        font-size: 20px;
        position: relative;
        top: 0;
    }
    
    .header__placeholder {
        display: none;
        border-top: 1px solid black;
        padding-top: 43px;
    }
    
    .submenu {
        background-color: #f4f4f5;
        border-bottom: 1px solid #373737;
        border-top: 3px solid #373737; 
    }
    
`;



// WEBPACK FOOTER //
// ./src/scripts/reusable/DeliveryIcons/DeliveryIcons.DownloadPfdHtmlSyles.jsx